import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <section className="relative w-full min-h-screen overflow-x-hidden bg-black font-[Poppins]">
      <img
        src="images/top.png"
        alt="Top"
        className="pointer-events-none absolute top-0 left-1/2 w-[140%] max-w-none -translate-x-1/2 opacity-40 sm:w-full sm:max-w-2xl sm:opacity-60"
      />
      <img
        src="images/leftcorner.png"
        alt="Left"
        className="pointer-events-none absolute bottom-[-4rem] left-[-6rem] hidden w-64 opacity-40 sm:left-[-3rem] sm:block sm:opacity-70 md:bottom-0"
      />
      <img
        src="images/right-corner.png"
        alt="Right"
        className="pointer-events-none absolute bottom-[-4rem] right-[-6rem] hidden w-64 opacity-40 sm:right-[-3rem] sm:block sm:opacity-70 md:bottom-0"
      />
      <img
        src="images/synergy.png"
        alt="Left Coin"
        className="pointer-events-none absolute left-[-4rem] top-1/3 hidden w-32 opacity-50 sm:block sm:left-6 sm:w-40 sm:opacity-80 md:left-12 md:w-[10rem]"
      />
      <img
        src="images/synergy.png"
        alt="Right Coin"
        className="pointer-events-none absolute right-[-3rem] top-[22%] hidden w-20 opacity-50 sm:block sm:right-10 sm:w-28 sm:opacity-80 md:right-12"
      />

      <div className="relative z-20 flex min-h-screen flex-col">
        <div className="flex items-center justify-between px-4 py-5 sm:px-6">
          <img src="images/login-logo.png" alt="Logo" className="h-8 w-auto sm:h-10" />
          <button
            onClick={() => navigate("/signup")}
            className="rounded-full border border-white/20 px-4 py-1.5 text-sm text-white transition hover:border-white/40 hover:text-purple-300 sm:px-5"
          >
            Sign Up
          </button>
        </div>

        <div className="flex flex-1 items-start justify-center px-4 pb-14 pt-8 sm:items-center sm:px-6">
          <div className="w-full max-w-[560px] text-center">
            <h1 className="text-3xl font-semibold tracking-tight text-transparent bg-gradient-to-r from-[#ECEFF0] to-[#E5C0FF] bg-clip-text sm:text-4xl">
              Reset your Password
            </h1>
            <p className="mx-auto mt-3 max-w-md text-sm text-gray-300 sm:text-base">
              Please set a new Password for your account.
            </p>

            <div className="mx-auto mt-10 max-w-md text-left">
              <label className="mb-2 block text-sm text-gray-200">New Password</label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="****************"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full rounded-xl border border-white/10 bg-black/60 px-4 py-3 pr-12 text-sm text-gray-100 placeholder:text-gray-500 focus:border-purple-400 focus:outline-none"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-lg text-gray-300 transition hover:text-white"
                >
                  👁️
                </button>
              </div>
            </div>

            <div className="mx-auto mt-5 max-w-md text-left">
              <label className="mb-2 block text-sm text-gray-200">Confirm new Password</label>
              <div className="relative">
                <input
                  type={showConfirm ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="****************"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="w-full rounded-xl border border-white/10 bg-black/60 px-4 py-3 pr-12 text-sm text-gray-100 placeholder:text-gray-500 focus:border-purple-400 focus:outline-none"
                />
                <button
                  type="button"
                  onClick={() => setShowConfirm((prev) => !prev)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-lg text-gray-300 transition hover:text-white"
                >
                  👁️
                </button>
              </div>
            </div>

            <div className="mx-auto mt-6 max-w-md">
              <button
                type="button"
                className="w-full rounded-xl bg-gradient-to-r from-[#7F3FFD] to-[#9F4FFF] py-3 text-sm font-semibold text-white transition hover:brightness-110"
              >
                Set Pin
              </button>
            </div>

            <p className="mt-6 text-center text-xs text-gray-400">
              By using SynergyCoin, you agree to our terms and policy.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
